import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { $e } from './utils/Translate.js';
import router from './router.js';
import App from './App.vue';

// ---
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
// ---
import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';
// ---
import './css/style.css'
// import tr from 'flowbite-datepicker/locales/tr';
// ---
import { CONSTANT_DJI_ERROR } from "@/utils/constant/dji_error.ts";

async function initApp() {
  var langcode = 'FRA';
  if (window.location.search) {
    let search = window.location.search.replace('?', '')
      .split('&')
      .filter((item) => item.includes('lang='));

    if (search.length > 0) {
      langcode = search[0].replace('lang=', '');
    }
  }

  const dji_error = CONSTANT_DJI_ERROR.get().dji_error;

  const app = createApp(App);
  app.use(router);
  app.use(createPinia());
  app.use(Vue3Toastify, { dangerouslyHTMLString: true });
  app.use(VueViewer);

  /**
   * TRADUCTION
   */

  app.config.globalProperties.$e = $e;
  app.config.globalProperties.$dji_error = (code) => {
    if (dji_error[code]) {
      let lang_key = 'fr';
      switch (langcode) {
        case 'FRA':
          lang_key = 'fr';
          break;
        case 'ENG':
          lang_key = 'en';
          break;
        case 'ESP':
          lang_key = 'es';
          break;
        case 'CHI':
          lang_key = 'zh';
          break;
        case 'DEU':
          lang_key = 'de';
          break;
        case 'ITA':
          lang_key = 'it';
          break;
        case 'NLD':
          lang_key = 'nl';
          break;
        case 'PRT':
          lang_key = 'pt';
          break;
        case 'TUR':
          lang_key = 'tr';
          break;
        default:
          lang_key = 'fr';
          break;
      }

      if (
        dji_error[code][lang_key] != undefined &&
        dji_error[code][lang_key] != ''
      ) {
        return dji_error[code][lang_key];
      }
      else if (
        dji_error[code]['en'] != undefined &&
        dji_error[code]['en'] != ''
      ) {
        return dji_error[code]['en'];
      }
      else if (
        dji_error[code]['fr'] != undefined &&
        dji_error[code]['fr'] != ''
      ) {
        return dji_error[code]['fr'];
      }
      else if (
        dji_error[code]['zh'] != undefined &&
        dji_error[code]['zh'] != ''
      ) {
        return dji_error[code]['zh'];
      }

      return app.config.globalProperties.$e('Erreur inconnue') + "#" + code;
    }
    return app.config.globalProperties.$e('Erreur inconnue') + "#" + code;
  };

  /**
   * FIN TRADUCTION
   */

  app.mount('#app');
}

// Initialiser l'application
initApp();
